import { put } from 'redux-saga/effects';

import { setUcTabValue } from '../../actions';

// eslint-disable-next-line import/prefer-default-export
export function* inboxTabValue({ payload }) {
  yield put(setUcTabValue(payload));
}
